import { Link } from 'react-router-dom';

interface Feat {
  icon: string;
  title: string;
  body: string;
}

const FEATURES: Feat[] = [
  {
    icon: '🔄',
    title: 'Cross-device sync',
    body: 'Start on your phone, continue on the web, finish on Windows. Your reading position and library follow you automatically — last change wins, no fuss.',
  },
  {
    icon: '📖',
    title: 'In-browser reader',
    body: 'Read EPUBs and PDFs right in your browser — no plugins. Choose light, sepia, gray, dark or black themes, and one- or two-page layouts.',
  },
  {
    icon: '🗣️',
    title: 'Natural read-aloud voices',
    body: 'The same lifelike neural voices as the app, running privately on your device. Download once (~once-off), then listen offline — with the current sentence highlighted as it reads.',
  },
  {
    icon: '📁',
    title: 'Your library, your files',
    body: 'Point ScrollWind at a folder on your PC and it reads and saves your books there. No lock-in — your files stay yours, in formats you already own.',
  },
  {
    icon: '🔐',
    title: 'Private phone → web transfer',
    body: 'Pull a book straight from your phone to this browser over an encrypted relay while both are signed in. Nothing is stored on our servers.',
  },
];

export function Features() {
  return (
    <div className="page-narrow">
      <header className="pagehead">
        <h1>Everything ScrollWind does</h1>
        <p className="lede">A calm, fast reader that respects your books — and your privacy.</p>
      </header>

      <div className="featurelist">
        {FEATURES.map((f) => (
          <article key={f.title} className="card featurecard">
            <span className="feat-icon" aria-hidden>{f.icon}</span>
            <div>
              <h2>{f.title}</h2>
              <p className="muted">{f.body}</p>
            </div>
          </article>
        ))}
      </div>

      <div className="cta-row">
        <Link className="btn" to="/login">Get started</Link>
        <Link className="navlink" to="/about">About ScrollWind →</Link>
      </div>
    </div>
  );
}
